export default __webpack_public_path__ + "static/media/pokerstars.e743aeb6.png";